import { useQuery } from "@tanstack/react-query";
import { Link, createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { LoadingIndicator } from "../../components/LoadingIndicator";
import { SignPlayer } from "../../components/SignPlayer";
import { saveRecentSignWord } from "../../lib/recent-sign-words";
import { fetchSignWord } from "../../lib/sign-words-api";

export const Route = createFileRoute("/_app/sign-words_/$code")({
  component: SignWordPage,
});

function SignWordPage() {
  const { code } = Route.useParams();
  const router = useRouter();
  const wordQuery = useQuery({
    queryKey: ["sign-word", code],
    queryFn: () => fetchSignWord(code),
  });

  const word = wordQuery.data;
  // 単語を開いたら「最近見た」に残す
  useEffect(() => {
    if (word) {
      saveRecentSignWord({
        code: word.code,
        title: word.title,
        ruby: word.ruby,
      });
    }
  }, [word]);

  return (
    <div className="space-y-4">
      <Link
        to="/sign-words"
        // 検索から来たときは履歴を戻って、検索語と候補をそのまま復元する
        // （直接開いたときは履歴が無いので、普通のリンクとして検索画面へ）
        onClick={(e) => {
          if (window.history.length > 1) {
            e.preventDefault();
            router.history.back();
          }
        }}
        className="text-sm text-neutral-500 hover:text-neutral-700"
      >
        ← もどる
      </Link>

      {wordQuery.isLoading && (
        <LoadingIndicator label="読み込み中..." variant="bar" />
      )}

      {wordQuery.isError && (
        <div className="rounded-xl bg-red-50 border border-red-200 p-4 text-sm text-red-700">
          手話データの読み込みに失敗しました: {wordQuery.error.message}
        </div>
      )}

      {wordQuery.data && (
        <>
          <p className="text-sm text-neutral-600">{wordQuery.data.title}</p>
          <SignPlayer
            words={wordQuery.data.words}
            showSequenceControl={false}
          />
        </>
      )}
    </div>
  );
}
